import { Button } from "react-bootstrap";
import image from "../img/image-password.png";
import { useNavigate } from "react-router";

function SuccessResetPassword() {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate("/login");
    }
    return (
        <>
            <section className="container-fluid" style={{ background: "#D6E4FF", minHeight: "100vh" }}>
                <div>
                    <div className="kl-succes-image">
                        <img src={image} alt="reset password" />
                    </div>
                    <div className="kl-message-reset-password">
                        <h1>
                            Mot de passe crée avec succès !
                        </h1>
                        <p>
                            Veuillez vous reconnecter avec votre nouveau mot de passe.
                        </p>
                    </div>
                    <div className="kl-button-start-contab">
                        <Button
                            type="submit"
                            variant={"primary"}
                            size="lg"
                            onClick={handleClick}
                        >
                            Revenir sur Comptaride
                        </Button>
                    </div>
                </div>
            </section>
        </>
    );
}

export default SuccessResetPassword;